import { Phone, Mail, MessageCircle, ArrowRight } from 'lucide-react';
import { Button, Card } from '../../ui';
import { companyInfo } from '../../../data';

export interface CTAProps {
    onContactClick: () => void;
}

export function CTA({ onContactClick }: CTAProps) {
    return (
        <section className="py-12 md:py-16 bg-gradient-to-br from-main-color via-main-color to-blue-900">
            <div className="container mx-auto px-4 max-w-[1240px]">
                <Card variant="elevated" className="bg-white text-center">
                    <div className="py-6 md:py-10">
                        <h2 className="font-font-s text-2xl md:text-4xl font-bold text-main-color mb-4">
                            Contactati-ne acum!
                        </h2>
                        <p className="font-font-s text-gray-700 text-lg mb-8 max-w-2xl mx-auto">
                            Suntem aici sa va ajutam sa gasiti solutia de asigurare perfecta pentru nevoile
                            dumneavoastra.
                        </p>

                        {/* Contact Buttons */}
                        <div className="flex flex-wrap justify-center gap-4 mb-8">
                            <a
                                href={`mailto:${companyInfo.contact.emails[0]}`}
                                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-main-color rounded-lg font-medium hover:bg-gray-100 transition-colors shadow-lg"
                            >
                                <Mail className="w-5 h-5" />
                                Email
                            </a>
                            <a
                                href={`tel:${companyInfo.contact.phones[0].replace(/\./g, '')}`}
                                className="inline-flex items-center gap-2 px-6 py-3 bg-green-500 text-white rounded-lg font-medium hover:bg-green-600 transition-colors shadow-lg"
                            >
                                <Phone className="w-5 h-5" />
                                Telefon
                            </a>
                            <a
                                href={`https://wa.me/40${companyInfo.contact.phones[0].replace(/\./g, '').replace(/^0/, '')}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 transition-colors shadow-lg"
                            >
                                <MessageCircle className="w-5 h-5" />
                                WhatsApp
                            </a>
                        </div>

                        {/* Working Hours */}
                        <div className="text-gray-600 text-sm font-font-s">
                            <p>
                                Program:{' '}
                                <span className="text-main-color font-semibold">
                                    {companyInfo.contact.workingHours.days} {companyInfo.contact.workingHours.hours}
                                </span>
                            </p>
                            <p className="mt-1">Urgente in afara programului: Tel/WhatsApp disponibil</p>
                        </div>

                        {/* View Contact Details */}
                        <Button
                            onClick={onContactClick}
                            variant="link"
                            className="text-main-color hover:text-main-color/80 mt-4 underline underline-offset-2"
                            icon={<ArrowRight className="w-4 h-4" />}
                            iconPosition="right"
                        >
                            Vezi toate datele de contact
                        </Button>
                    </div>
                </Card>
            </div>
        </section>
    );
}
